"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.TonConnectBridgeType = void 0;
var TonConnectBridgeType;
(function (TonConnectBridgeType) {
    TonConnectBridgeType["Remote"] = "remote";
    TonConnectBridgeType["Injected"] = "injected";
})(TonConnectBridgeType = exports.TonConnectBridgeType || (exports.TonConnectBridgeType = {}));
